<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import { createSmsTemplateApi, deleteSmsTemplateApi, getSmsTemplateApi, updateSmsTemplateApi } from '../api/sms'

  export default {
    name: 'SmsTemplate',
    data(){
      return {
        tableData: [],
        page: 1,
        total: 0,
        addVisible: false,
        editVisible: false,
        addForm: {
          id: '',
          name: '',
          desc: ''
        },
        editForm: {
          id: '',
          name: '',
          desc: '',
          ID: null
        }
      }
    },
    methods: {
      resetAddForm(){
        this.$refs.addFormRef.resetFields()
      },
      resetEditForm(){
        this.editForm.id = ''
        this.editForm.ID = null
        this.editForm.name = ''
        this.editForm.desc = ''
      },
      handleAddFormDialogClosed(){
        this.$refs.addFormRef.resetFields()
      },
      handleEditFormDialogClosed(){
        this.editForm.id = ''
        this.editForm.name = ''
        this.editForm.desc = ''
      },
      async submitAddForm(){
        if(!this.addForm.id || !this.addForm.name || !this.addForm.desc) return ElMessage('请填写信息')
        const data = {
          templateId: this.addForm.id, 
          name: this.addForm.name, 
          desc: this.addForm.desc
        }
        const res = await createSmsTemplateApi(data)
        if(res.code == 0){
          this.$refs.addFormRef.resetFields()
          ElMessage.success('新增成功')
          this.getTableData()
        }
      },
      async getTableData(){
        const params = {
          page: this.page,
          pageSize: 10
        }
        const res = await getSmsTemplateApi(params)
        if(res.code == 0){
          this.total = res.data.total
          this.tableData = res.data.list
        }else {
          this.total = 0
          this.tableData = []
          ElMessage.error(res.msg)
        }
      },
      editSms(row){
        this.editForm.id = row.templateId
        this.editForm.name = row.name
        this.editForm.desc = row.desc
        this.editForm.ID = row.ID
        this.editVisible = true
      },
      async sumbitEditForm(){
        if(!this.editForm.id || !this.editForm.name || !this.editForm.desc) return ElMessage('请填写信息')
        const data = {
          templateId: this.editForm.id,
          name: this.editForm.name,
          desc: this.editForm.desc,
          ID: this.editForm.ID
        }
        const res = await updateSmsTemplateApi(data)
        if(res.code == 0){
          ElMessage.success('修改成功')
          this.editVisible = false
          this.getTableData()
        }else {
          ElMessage.error(res.msg)
        }
      },
      async deleteSms(row){
        ElMessageBox.confirm(
          '确定要删除吗？',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
          .then(async () => {
            const data = {
              id: row.ID
            }
            const res = await deleteSmsTemplateApi(data)
            if(res.code == 0){
              ElMessage({
                type: 'success',
                message: '删除成功',
              })
              this.getTableData()
            }else {
              ElMessage({
                type: 'error',
                message: res.msg,
              })
            }
          })
          .catch(() => {
            ElMessage({
              type: 'info',
              message: '已取消',
            })
          })
      }
    },
    watch: {
      page: {
        handler(){
          this.getTableData()
        },
        immediate: true
      }
    },
  }
</script>

<template>
  <div style="box-sizing: border-box; background: white; padding: 10px;">
    <div>
      <el-button type="primary" @click="addVisible = true">新增短信模板</el-button>
    </div>
    <div style="margin-top: 20px;">
     <el-table :data="tableData" style="width: 100%; border: 1px solid #efefef">
        <el-table-column prop="templateId" label="模板ID" width="180" />
        <el-table-column prop="name" label="名称" width="180" show-overflow-tooltip />
        <el-table-column prop="desc" label="描述" show-overflow-tooltip />
        <el-table-column label="操作">
          <template #default="{ row }">
            <el-button type="primary" size="mini" @click="editSms(row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="deleteSms(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: center; margin-top: 20px;">
        <el-pagination background layout="prev, pager, next" hide-on-single-page :total="total" v-model:current-page="page" />
      </div>
    </div>
    <el-dialog title="新增" v-model="addVisible" @closed="handleAddFormDialogClosed">
      <div>
        <el-form ref="addFormRef" :model="addForm" label-width="100px">
          <el-form-item label="模板ID" prop="id" required>
            <el-input v-model="addForm.id" style="width: 240px;" />
          </el-form-item>
          <el-form-item label="名称" prop="name" required>
            <el-input v-model="addForm.name" style="width: 240px;" />
          </el-form-item>
          <el-form-item label="描述" prop="desc" required>
            <el-input type="textarea" :rows="5" v-model="addForm.desc" style="width: 240px;" />
          </el-form-item>
          <el-form-item>
            <el-button @click="resetAddForm">重置</el-button>
            <el-button type="primary">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="新增" v-model="addVisible">
      <div>
        <el-form ref="addFormRef" :model="addForm" label-width="100px">
          <el-form-item label="模板ID" prop="id">
            <el-input v-model="addForm.id" style="width: 240px;" />
          </el-form-item>
          <el-form-item label="名称" prop="name">
            <el-input v-model="addForm.name" style="width: 240px;" />
          </el-form-item>
          <el-form-item label="描述" prop="desc">
            <el-input type="textarea" :rows="5" v-model="addForm.desc" style="width: 240px;" />
          </el-form-item>
          <el-form-item>
            <el-button @click="resetAddForm">重置</el-button>
            <el-button type="primary" @click="submitAddForm">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="编辑" v-model="editVisible" @closed="handleEditFormDialogClosed">
      <div>
        <el-form ref="editFormRef" :model="editForm" label-width="100px">
          <el-form-item label="模板ID" prop="id">
            <el-input v-model="editForm.id" style="width: 240px;" />
          </el-form-item>
          <el-form-item label="名称" prop="name">
            <el-input v-model="editForm.name" style="width: 240px;" />
          </el-form-item>
          <el-form-item label="描述" prop="desc">
            <el-input type="textarea" :rows="5" v-model="editForm.desc" style="width: 240px;" />
          </el-form-item>
          <el-form-item>
            <el-button @click="resetEditForm">重置</el-button>
            <el-button type="primary" @click="sumbitEditForm">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped>

</style>